import { render, staticRenderFns } from "./DisplaySendEmailAction.vue?vue&type=template&id=aabb9e80&"
import script from "./DisplaySendEmailAction.vue?vue&type=script&lang=js&"
export * from "./DisplaySendEmailAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports